import visualBlock from './visual-block';
import ScrollMagic from "scrollmagic";
import { PageEvent } from '~/pages/page.js';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default class visualBlockDesktop extends visualBlock {

    constructor(...args) {

        super(...args);

        this._isHome = this.dom.component.classList.contains('is-home');
        this._isDesktop = ( ENV.device == 'desktop' );

        this._retrieveDOM();

    }

    _retrieveDOM() {

        this.dom.animate = {
            background : this.dom.component.querySelector('.js-media-mask'),
            mask : this.dom.component.querySelector('.js-anim-mask'),
            text : [].slice.call( this.dom.component.querySelectorAll('.js-textual-content') ),
        };

        if( this.dom.animate.mask ) {
            this._maskOpacity = parseFloat( this.dom.animate.mask.dataset.opacity );
        }
    }

    init() {
        super.init();

        if( this._isHome  == false)
            this._initScrollAnim();
    }


    _initScrollAnim() {
        if( this._isDesktop )
            this._animBackground();
        this._animContent();
    }

    _animBackground() {

        // Create Tweenmax Animation
        let tweenBackground = new TimelineMax();
        if( this.dom.animate.background )
        tweenBackground
            .fromTo( this.dom.animate.background, 2, {scale: 1.15, y: '-50%', z: 0.01}, { scale: 1.01, y: '-50%', z: 0.01, ease: Power0.easeNone }, 'init')
        if( this.dom.animate.mask )
            tweenBackground.fromTo( this.dom.animate.mask, 2, {opacity: 0}, { opacity: this._maskOpacity, ease: Power1.easeOut }, 'init')

        // tweenBackground
        //     .fromTo( this.dom.animate.background, 5, {scale: 1.15, z: '0.01px'}, { scale: 1.01, z: '0.01px', ease: Power1.easeOut }, 'init')
        // if( this.dom.animate.mask )
        //     tweenBackground.fromTo( this.dom.animate.mask, 2, {opacity: 0}, { opacity: this._maskOpacity, ease: Power1.easeOut }, 'init+=2')


        // Plug the tween to ScrollMagic Scene
        this._scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            offset: -window.innerHeight / 2,
            duration: this.dom.component.offsetHeight * 1.5
        });
        this._scene.setTween( tweenBackground );

        this.emit( PageEvent.ADD_SCENE, this._scene );
    }

    _animContent() {

        let tweenContent = new TimelineMax();

        if( this.dom.animate.text.length > 0 )
            tweenContent
                .fromTo( this.dom.animate.text, 5,{y:300, z: '0.02px'}, { y: '-50%', z: '0.02px', ease: Power4.easeOut }, 'init')

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            duration: this.dom.component.offsetHeight
        });
        scene.setTween( tweenContent );

        this.emit( PageEvent.ADD_SCENE, scene );
    }

    resize(width, height) {

        if( this._scene ) {
            this._scene.duration( this.dom.component.offsetHeight * 1.5 );
            this._scene.offset( -window.innerHeight / 2 );
        }

    }

    /*
    init() {
    }

    unbind() {
    }
    resize(width, height) {
    }
    */
}




// WEBPACK FOOTER //
// src/js/components/visual-block/visual-block.desktop.js